// Career Miniapp — t() translation hook
import { useI18nContext } from './I18nProvider';
export function useT() {
    const i18n = useI18nContext();
    function t(key, fallback) {
        if (i18n.system && i18n.system[key])
            return i18n.system[key];
        return fallback != null ? fallback : key;
    }
    function tClient(module, key, fallback) {
        if (i18n.client && i18n.client[module] && i18n.client[module][key]) {
            return i18n.client[module][key];
        }
        return fallback != null ? fallback : key;
    }
    // tContent: per-language common/content szótár (admin Forditasok / Tartalom szovegek).
    // Használat: t() helyett ha a szöveg a careersite Tartalom szövegeit szerkeszti.
    function tContent(key, fallback) {
        if (i18n.content && i18n.content[key])
            return i18n.content[key];
        return fallback != null ? fallback : key;
    }
    // tContact: per-language common/contact szótár.
    function tContact(key, fallback) {
        if (i18n.contactTexts && i18n.contactTexts[key])
            return i18n.contactTexts[key];
        return fallback != null ? fallback : key;
    }
    return { t, tClient, tContent, tContact, current: i18n.current };
}
